export const companyLinks = [
  { label: "About Us", path: "/about" },
  { label: "Business Partners", path: "/business-partners" },
  { label: "Ideology", path: "/ideology" },
  { label: "Clients", path: "/outcess-clients" },
  { label: "Gallery", path: "/gallery" },
  { label: "FAQ", path: "/faqs" },
];

export const solutionLinks = [
  {
    label: "Business Process Outsourcing",
    path: "/business-process-outsourcing",
  },
  {
    label: "AI Driven Customer Engagement",
    path: "/customer-engagement-solutions",
  },
  {
    label: "AI Governance Lifecycle",
    path: "/ai-governance-lifecycle",
  },
  {
    label: "AI Debt Recovery",
    path: "/ai-debt-recovery",
  },
  {
    label: "Agentic AI",
    path: "/agentic-ai",
  },
];
